/* eslint camelcase: 0, no-underscore-dangle: 0 */

import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import * as actionCreators from '../actions/auth';
import Typography from '@material-ui/core/Typography';
import { validateEmail } from '../utils/misc';
import PropTypes from "prop-types";
import { browserHistory } from 'react-router';


function mapStateToProps(state) {
    return {
        isAuthenticating: state.auth.isAuthenticating,
        isAuthenticated: state.auth.isAuthenticated,
        statusText: state.auth.statusText,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}


const paperStyle = {
    marginTop: 100,
    paddingBottom: 50,
    paddingTop: 25,
    padding: 20,
    width: '100%',
    textAlign: 'center',
    display: 'inline-block',
};



@connect(mapStateToProps, mapDispatchToProps)
class LoginView extends React.Component {
    constructor(props) {
        super(props);
        const redirectRoute = '/main';
        this.state = {
            email: '',
            password: '',
            email_error_text: null,
            password_error_text: null,
            redirectTo: redirectRoute,
            disabled: true,
            statusText: '',
        };
    }

    componentWillMount(){
        if(this.props.isAuthenticated){
            browserHistory.push('/main')
        }
    }


    isDisabled() {
        let email_is_valid = false;
        let password_is_valid = false;

        if (this.state.email === '') {
            this.setState({
                email_error_text: null,
            });
        } else if (validateEmail(this.state.email)) {
            email_is_valid = true;
            this.setState({
                email_error_text: null,
            });

        } else {
            this.setState({
                email_error_text: 'Email invalido',
            });
        }

        if (this.state.password === '' || !this.state.password) {
            this.setState({
                password_error_text: null,
            });
        } else if (this.state.password.length >= 6) {
            password_is_valid = true;
            this.setState({
                password_error_text: null,
            });
        } else {
            this.setState({
                password_error_text: 'Verifique su clave',
            });

        }

        if (email_is_valid && password_is_valid) {
            this.setState({
                disabled: false,
            });
        }

    }

    changeValue(e, type) {
        const value = e.target.value;
        const next_state = {};
        next_state[type] = value;
        this.setState(next_state, () => {
            this.isDisabled();
        });
    }

    _handleKeyPress(e) {
        if (e.key === 'Enter') {
            if (!this.state.disabled) {
                this.login(e);
            }
        }
    }

    login(e) {
        e.preventDefault();
        this.props.loginUser(this.state.email, this.state.password, this.state.redirectTo);
    }

    register(e){
        e.preventDefault();
        this.props.redirectToRoute('register')
    }
    render() {
        return (
            <div  className="col-md-6 col-md-offset-3" onKeyPress={(e) => this._handleKeyPress(e)}>
                <Paper style={paperStyle}>
                    <form role="form">
                        <Typography variant="h5" gutterBottom>
                        Ingrese su email y clave
                        </Typography>
                            {
                                this.props.statusText &&
                                <div className="alert alert-info">
                                    {this.props.statusText}
                                </div>
                            }

                            <div className="col-md-12">
                                <TextField
                                    autoFocus
                                    error={Boolean(this.state.email_error_text)}
                                    placeholder="user@mail.com"
                                    type="email"
                                    helperText={this.state.email_error_text}
                                    onChange={(e) => this.changeValue(e, 'email')}
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    error={Boolean(this.state.password_error_text)}
                                    placeholder="Password"
                                    type="password"
                                    helperText={this.state.password_error_text}
                                    onChange={(e) => this.changeValue(e, 'password')}
                                />
                            </div>
                            <div className="col-md-12">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    disabled={this.state.disabled}
                                    onClick={(e) => this.login(e)}
                                >
                                    Enviar
                            </Button>
                            </div>
                          
                    </form>
                </Paper>

            </div>
        );

    }
}

LoginView.propTypes = {
    loginUser: PropTypes.func,
    statusText: PropTypes.string,
};

export default LoginView;


// WEBPACK FOOTER //
// ./src/components/LoginView.js